module.exports = __webpack_public_path__ + "static/media/emojiIcon.c1f54aef.svg";